import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../store/actions/index';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ProjectunitModal = (props) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = data => {
    dispatch( props.onSubmitAction(data) ).then( dispatch(hideModal()) );
  }

  const intialValues = props.initialValues;

  const errorMessage = (errors, fieldName) => {
    return (errors[fieldName] !== undefined)?
       <div className="invalid-feedback">
          { t('modal.edit_projectunit.form.' + fieldName + '.' + errors[fieldName]['type']) }
        </div> : null
  }

  const isItValid = (errors, fieldName) => {
    return (errors[fieldName] !== undefined)? "is-invalid" : ""
  }

  return (
   	<Modal show={true} onHide={props.hideModal} animation={true}>
   		<div className="modal-header">
   			<h5 className="modal-title">{props.modalTitle}</h5>
   			<button type="button" onClick={props.hideModal} className="close btn btn-round" data-dismiss="modal" aria-label="Close"> <i className="material-icons">close</i>
   			</button>
   		</div>
   		<Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
  					<label htmlFor="title">{ t( 'modal.edit_projectunit.form.title.label' ) }</label>
            <textarea
              name="title"
              rows="5"
              defaultValue={intialValues.title}
              className={"form-control " + isItValid(errors, 'title') }
              ref={register({required: true, maxLength: 60})} />
              { errorMessage(errors, 'title') }
          </div>
          <div className="form-group">
  					<label htmlFor="description">{ t( 'modal.edit_projectunit.form.description.label' ) }</label>
            <textarea
              name="description"
              rows="5"
              defaultValue={intialValues.description}
              className="form-control"
              ref={register()} />
          </div>
        </form>
   		</Modal.Body>
   		<Modal.Footer>
   			<Button variant="secondary" onClick={props.hideModal}>{t( 'modals.common.button.close' )}</Button>
   			<button type="submit" onClick={handleSubmit(onSubmit)} className="btn btn-primary">{t( 'modals.common.button.save' )}</button>
   		</Modal.Footer>
   	</Modal>
  )
}


const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal())
})

export default connect(null, mapDispatchToProps)(ProjectunitModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ProjectunitModal.js